const customBlogPost = () => {
  const el = {
    main: "[data-custom-blog-post]",
    content: ".custom-blog-post__content",
    tocList: "[data-toc-list]",
    tocWrapper: "[data-toc]",
    tocIconTemplate: "[data-toc-icon-template]",
    recommendedSlider: ".custom-blog-post__recommended-slider",
    recommendedNext: ".custom-blog-post__recommended-next",
    recommendedPrev: ".custom-blog-post__recommended-prev",
    recommendedScrollbar: ".custom-swiper-scrollbar .swiper-scrollbar",
  };

  const init = () => {
    const sections = document.querySelectorAll(el.main);
    if (!sections.length) return;

    sections.forEach((section) => {
      handlerTableOfContents(section);
      handlerRecommendedSlider(section);
    });
  };

  const handlerTableOfContents = (section) => {
    const content = section.querySelector(el.content);
    const tocList = section.querySelector(el.tocList);
    const tocWrapper = section.querySelector(el.tocWrapper);
    const iconTemplate = section.querySelector(el.tocIconTemplate);
    if (!content || !tocList) return;

    const headings = content.querySelectorAll("h2");

    if (!headings.length) {
      if (tocWrapper) tocWrapper.style.display = "none";
      return;
    }

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = `section-${index + 1}-${slugify(heading.textContent)}`;
      }

      const li = document.createElement("li");
      const a = document.createElement("a");
      a.href = `#${heading.id}`;

      const textSpan = document.createElement("span");
      textSpan.textContent = heading.textContent;
      a.appendChild(textSpan);

      if (iconTemplate) {
        const iconClone = iconTemplate.content.cloneNode(true);
        a.appendChild(iconClone);
      }

      li.appendChild(a);
      tocList.appendChild(li);
    });
  };

  const handlerRecommendedSlider = (section) => {
    const sliderEl = section.querySelector(el.recommendedSlider);
    if (!sliderEl) return;

    if (typeof Swiper === "undefined") {
      console.error("Swiper belum ter-load");
      return;
    }

    new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 600,
      navigation: {
        nextEl: '.custom-blog-post__recommended-next',
        prevEl: '.custom-blog-post__recommended-prev',
      },
      scrollbar: {
        el: '.custom-swiper-scrollbar .swiper-scrollbar',
        draggable: true,
        dragSize: 'auto',
        snapOnRelease: true,
        hide: false,
      },
    });
  };

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }

  document.addEventListener("DOMContentLoaded", init);
};

try {
  customBlogPost();
} catch (error) {
  console.error("customBlogPost", error);
}